/**
 * File tiles-carousel.js
 *
 * Handles Swiper Carousels for the homepage tiles carousel.
 */

// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable import/no-unresolved */
import Swiper, { Pagination, EffectFade } from 'swiper';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';

document.addEventListener( 'DOMContentLoaded', function () {
	if ( document.querySelectorAll( '.tiles-carousel' ).length ) {
		new Swiper( '.tiles-carousel', {
			modules: [ Pagination, EffectFade ],
			effect: 'fade',
			speed: 200,
			pagination: {
				el: '.tile-pagination',
				clickable: true,
				renderBullet( index, className ) {
					const slideColor = this.slides[ index ].dataset.color;
					const slideTitle = this.slides[ index ].dataset.title;
					const slideIcon = this.slides[ index ].dataset.icon;
					return (
						'<span class="' +
						className +
						' magnatiles-pager tile-pager-' +
						slideColor +
						'"><span class="pager-content"><span class="pager-title">' +
						slideTitle +
						'</span><img src="' +
						slideIcon +
						'" alt="" role="presentation" /></span></span>'
					);
				},
			},
		} );

		function reportWindowSize() {
			const pager = document.querySelector(
				'.tile-pagination .pager-content'
			);
			const pagerWidth = pager.clientWidth;
			const pagerFontSize = pagerWidth * 0.135;
			document
				.querySelectorAll(
					'.tile-pagination .pager-content .pager-title'
				)
				.forEach( function ( text ) {
					text.style.fontSize = pagerFontSize + 'px';
				} );
		}

		window.onresize = reportWindowSize;
		reportWindowSize();
	}
} );
